const headers = [
  {
    text: '', value: '', align: 'left', sortable: false,
  },
  {
    text: 'Object ID', value: 'objectid', align: 'left',
  },
  {
    text: 'Municipio', value: 'municipio', align: 'left',
  },
  {
    text: 'Dirección', value: 'dirección', align: 'left',
  },
  {
    text: 'Marca', value: 'marca', align: 'left',
  },
];

export default headers;
